import { render, staticRenderFns } from "./PublishingBookDetails.vue?vue&type=template&id=55a65678&scoped=true&"
import script from "./PublishingBookDetails.vue?vue&type=script&lang=js&"
export * from "./PublishingBookDetails.vue?vue&type=script&lang=js&"
import style0 from "./PublishingBookDetails.vue?vue&type=style&index=0&id=55a65678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a65678",
  null
  
)

export default component.exports